var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0.5H14.25C14.875 0.5 15.5 1.125 15.5 1.75V14.25C15.5 14.875 14.875 15.5 14.25 15.5H1.75C1.125 15.5 0.5 14.875 0.5 14.25V1.75C0.5 1.125 1.125 0.5 1.75 0.5ZM6.82353 11.2353L9.25 8L13 13H8H5.5H3L5.5 9.25L6.82353 11.2353Z",
    fill: "#FF9625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.d9ef5096bf060445e897f342944c2c44.svg";
export { ForwardRef as ReactComponent };